var map = {
	"./bim1.png": "ozKm",
	"./bim11.png": "ZIHG",
	"./bim12.png": "lbeC",
	"./bim13.png": "CLE5",
	"./bim2.png": "B01W",
	"./bim3.png": "DSxP",
	"./lunbo1.png": "W76v",
	"./shouye1.png": "hT3U",
	"./shouye2.png": "NFYx",
	"./shouye3.png": "Nf8r",
	"./shouye4.png": "/4WN"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Br1l";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shouye ^\.\/.*$
// module id = Br1l
// module chunks = 17